import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "box" }
const _hoisted_2 = { class: "box-content" }
const _hoisted_3 = { class: "main" }
const _hoisted_4 = {
  key: 0,
  class: "progress-wrapper"
}
const _hoisted_5 = {
  key: 1,
  class: "content"
}
const _hoisted_6 = { style: {"text-align":"center"} }
const _hoisted_7 = {
  key: 0,
  class: "p-text-center"
}
const _hoisted_8 = {
  key: 1,
  class: "p-text-center"
}
const _hoisted_9 = {
  key: 2,
  class: "p-mb-4"
}
const _hoisted_10 = { class: "reg-form" }
const _hoisted_11 = { class: "card-reg" }
const _hoisted_12 = { class: "p-float-label" }
const _hoisted_13 = {
  class: "requiredLabel",
  for: "salutation"
}
const _hoisted_14 = { key: 0 }
const _hoisted_15 = { class: "p-float-label" }
const _hoisted_16 = { for: "title" }
const _hoisted_17 = { key: 0 }
const _hoisted_18 = { class: "p-float-label" }
const _hoisted_19 = {
  class: "requiredLabel",
  for: "firstname"
}
const _hoisted_20 = { key: 0 }
const _hoisted_21 = { class: "p-float-label" }
const _hoisted_22 = {
  class: "requiredLabel",
  for: "lastname"
}
const _hoisted_23 = { key: 0 }
const _hoisted_24 = { class: "span-2 phone" }
const _hoisted_25 = { class: "p-float-label" }
const _hoisted_26 = /*#__PURE__*/_createElementVNode("div", { class: "country-prefix" }, "+49", -1)
const _hoisted_27 = { key: 0 }
const _hoisted_28 = { class: "span-2" }
const _hoisted_29 = { class: "p-float-label" }
const _hoisted_30 = { key: 0 }
const _hoisted_31 = {
  key: 0,
  class: "span-2"
}
const _hoisted_32 = { class: "p-float-label" }
const _hoisted_33 = { for: "username" }
const _hoisted_34 = { key: 0 }
const _hoisted_35 = {
  key: 0,
  id: "no-email",
  class: "p-error"
}
const _hoisted_36 = { class: "span-2" }
const _hoisted_37 = { class: "p-float-label" }
const _hoisted_38 = {
  class: "p-pl-2 p-ml-2 p-mt-0",
  style: {"line-height":"1.5"}
}
const _hoisted_39 = { for: "password" }
const _hoisted_40 = {
  key: 0,
  id: "password-weak",
  class: "p-error"
}
const _hoisted_41 = { class: "span-2 p-mb-4" }
const _hoisted_42 = { class: "p-float-label m-span-2" }
const _hoisted_43 = { for: "password2" }
const _hoisted_44 = {
  key: 0,
  class: "p-error"
}
const _hoisted_45 = {
  key: 0,
  style: {"margin-top":"10px","margin-bottom":"20px"}
}
const _hoisted_46 = { class: "p-float-label terms-and-conditions p-mb-4" }
const _hoisted_47 = {
  class: "pointerevents no-tooltip",
  for: "termsandconditions"
}
const _hoisted_48 = {
  href: "/datenschutz",
  target: "_blank"
}
const _hoisted_49 = { key: 0 }
const _hoisted_50 = {
  key: 1,
  class: "p-error"
}
const _hoisted_51 = { class: "call-to-action mobile-bottom-nav" }
const _hoisted_52 = /*#__PURE__*/_createElementVNode("i", { class: "pi pi-angle-left" }, null, -1)
const _hoisted_53 = /*#__PURE__*/_createElementVNode("i", { class: "pi pi-angle-right p-ml-1" }, null, -1)
const _hoisted_54 = /*#__PURE__*/_createElementVNode("i", { class: "pi pi-angle-right" }, null, -1)
const _hoisted_55 = { class: "sidebar" }
const _hoisted_56 = { class: "content" }
const _hoisted_57 = /*#__PURE__*/_createElementVNode("div", { class: "mobile-hide sidebar-image" }, [
  /*#__PURE__*/_createElementVNode("img", { src: "/kandidaten/img/Step 0-tech.png" })
], -1)
const _hoisted_58 = { class: "mobile-hide headline" }

import { computed, getCurrentInstance, ref, watch } from "vue";
    import useVuelidate from '@vuelidate/core';
    import { email, helpers, required, requiredIf } from '@vuelidate/validators';
    import { useI18n } from "vue-i18n";
    import { createAuthenticationService } from '../../services/authenticationService';
    import { createCandidateService } from '@/services/candidateService';
    import {convertSalutationForDatabase, getFeatureFlagWithApp} from "@/helper";
    import { CandidateProfile } from "@/models/CandidateProfile";
    import { useRoute } from "vue-router";
    import { BrandId } from "@/models/BrandIds";
    import { createCityZipCodeService } from "@/services/cityZipCodeService";
    import { PencilIcon } from "@heroicons/vue/outline";
    import Timeline from "@/registration/tech/wizard/Timeline.vue";
    import Header from "@/components/Header.vue";
    import validator from "validator";

    
export default /*#__PURE__*/_defineComponent({
  __name: 'Registration',
  props: ["isDirectSignUp"],
  emits: ['close', 'registered', 'login', 'prev'],
  setup(__props, { expose: __expose, emit: __emit }) {

    const props = __props;
    const isDirectSignUp = ref(props.isDirectSignUp);
    const emit = __emit;
    const { t } = useI18n();
    const route = useRoute();
    const app = getCurrentInstance();
    const display = ref(false);
    const user = ref([]);
    const step = ref(0);
    const showLoginInsteadOfContinue = ref(false);
    const close = function () {
        display.value = false;
        emit("close");
    }
    const registrationData = ref<CandidateProfile>([]);

    const titles = ref([null, "Dr.", "Prof.", "Prof. Dr."]);
    const salutations = computed(() => {
        return [
            t("salutations.mr"),
            t("salutations.mrs")
        ]
    });

    const login = () => {
        emit("login", null, { email: user.value.emailAddress });
        display.value = false;
    }

    const checkMail = async () => {
        if (!user.value?.emailAddress) {
            showLoginInsteadOfContinue.value = false;
            return;
        }

        if (!validator.isEmail(user.value.emailAddress)) {
            showLoginInsteadOfContinue.value = false;
            return;
        }
        showLoginInsteadOfContinue.value = await authenticationService.emailAlreadyExists(user.value.emailAddress);
    }

    const show = function (email: string, candidateData: CandidateProfile) {
        if (!candidateData)
            user.value.emailAddress = email;
        else
            user.value = candidateData;

        if (isDirectSignUp.value)
            step.value = 3;
        showSpinner.value = false;
        error.value = undefined;
        display.value = true;
    }
    const submit = ref(false);
    const error = ref();
    const showSpinner = ref(false);
    const authenticationService = createAuthenticationService(app);
    const passwordsNotMatch = ref(false);

    const signup = async () => {
        submit.value = true;
        passwordsNotMatch.value = user.value.password2 != user.value.password;
        if (validate() || passwordsNotMatch.value)
            return;
        showSpinner.value = true;
        error.value = undefined;

        const singUpSuccess = await authenticationService.signUpWithPassword({
            brandId: BrandId.ElliotBrowne,
            emailAddress: user.value.emailAddress,
            password: user.value.password,
            encryptedCandidateId: user.value.encryptedId,
            source: route.query.source ? route.query.source?.toString() : "organic"
        });

        if (singUpSuccess) {
            initRegistrationData();
            registrationData.value.brandId = BrandId.ElliotBrowne;
            if (route.query.source) {
                registrationData.value.sourceParam = route.query.source?.toString();
            } else {
                registrationData.value.sourceParam = "organic";
            }
            registrationData.value = { ...registrationData.value, ...user.value };
            registrationData.value.salutation = convertSalutationForDatabase(registrationData.value.salutation);

            const candidateService = await createCandidateService(app);
            const candidateId = await candidateService.getId();

            if (candidateId) {
                registrationData.value.id = candidateId;
                const inserted = await candidateService.updateCandidate(registrationData.value);
                if (inserted) {
                    emit("registered");
                    const candidateCvAddProfilePageIntegrationFeatureFlag = await getFeatureFlagWithApp(app, "candidateCvAddProfilePageIntegration");
                    if (candidateCvAddProfilePageIntegrationFeatureFlag) {
                        await candidateService.updated(candidateId);
                    }
                    close();
                }
            } else {
                console.error("failed to get candidate id for registration data", registrationData);
                error.value = t("registration.error2");
            }
        } else {
            if (singUpSuccess == false) {
                error.value = t("registration.error2");
            }
            if (singUpSuccess == null) {
                error.value = t("registration.error3");
            }
        }
        showSpinner.value = false;
    }

    const initRegistrationData = () => {
        if (!registrationData.value.areasOfExpertise)
            registrationData.value.areasOfExpertise = [];
        if (!registrationData.value.skills)
            registrationData.value.skills = [];

        if (!registrationData.value.jobTitles)
            registrationData.value.jobTitles = [];

        if (!registrationData.value.additionalCities)
            registrationData.value.additionalCities = [];

        if (!registrationData.value.reachableFederalStates)
            registrationData.value.reachableFederalStates = [];

        if (!registrationData.value.desiredCompanySizes)
            registrationData.value.desiredCompanySizes = [];

        if (!registrationData.value.desiredClientSizes)
            registrationData.value.desiredClientSizes = [];

        if (!registrationData.value.excludedCompanies)
            registrationData.value.excludedCompanies = [];

        //if (!registrationData.value.willingnessToChange)
        //    registrationData.value.willingnessToChange = WillingnessToChange.VeryHigh;

        if (!registrationData.value.fullTime)
            registrationData.value.fullTime = true;
    }

    const readableLocation = ref < string > ();
    const requestNameByZip = async (zip: string) => {
        const service = await createCityZipCodeService();
        if (zip) {
            const result = await service.zip(zip);

            if (result.status == 200) {
                if (result.data) {
                    const data = result.data as any;
                    return data.zip + ", " + data.cityName;
                }
            }
        }
        return null;
    };
    const locations = ref();
    const loadLocations = async (event) => {
        if (event.query.trim().length < 3) {
            locations.value = [];
        } else {
            const service = await createCityZipCodeService();
            const data = await service.locations(event.query.trim());
            locations.value = data.data;
        }
    };
    const locationItemSelected = (event) => {
        user.value.zipCode = event.value?.split(" ")[0];
    };

    watch(
        () => user.value.zipCode,
        async (zipCode) => {
            const result = await requestNameByZip(zipCode);
            readableLocation.value = result ? result : zipCode;
        }
    );

    const rules = computed(() => {
        return {
            acceptTermsAndConditions: {
                requiredIf: helpers.withMessage(t("registration.data.policy.please.accept"), requiredIf(() => {
                    return !isDirectSignUp.value;
                }))
            },
            salutation: { required: helpers.withMessage(t("validate.required.error"), required) },
            emailAddress: {
                required: helpers.withMessage(t("validate.required.error"), required),
                email: helpers.withMessage(t("validate.email.error"), email)
            },
            firstName: { required: helpers.withMessage(t("validate.required.error"), required) },
            lastName: { required: helpers.withMessage(t("validate.required.error"), required) },
            password: {
                required: helpers.withMessage(t("validate.required.error"), required),
            },
            password2: {
                required: helpers.withMessage(t("validate.required.error"), required),
            },
            zipCode: {
                requiredIf: helpers.withMessage(t("validate.required.error"), requiredIf(() => {
                    return !props.isDirectSignUp;
                })),
            },
            phoneNumber: {
                requiredIf: helpers.withMessage(t("validate.required.error"), requiredIf(() => {
                    return !props.isDirectSignUp;
                })),
            },
            academicTitle: {},
        }
    });

    const v$ = useVuelidate(rules, user);
    const validate = () => {
        v$.value.$touch();
        if (v$.value.$invalid) {
            return v$.value.$error;
        }
    }

    const prev = () => {
        emit("prev", user.value);
        display.value = false;
    }

    __expose({
        show,
        close,
    });


return (_ctx: any,_cache: any) => {
  const _component_ProgressSpinner = _resolveComponent("ProgressSpinner")!
  const _component_Dropdown = _resolveComponent("Dropdown")!
  const _component_InputText = _resolveComponent("InputText")!
  const _component_AutoComplete = _resolveComponent("AutoComplete")!
  const _component_Divider = _resolveComponent("Divider")!
  const _component_Password = _resolveComponent("Password")!
  const _component_Checkbox = _resolveComponent("Checkbox")!
  const _component_Button = _resolveComponent("Button")!
  const _component_Dialog = _resolveComponent("Dialog")!

  return (_openBlock(), _createBlock(_component_Dialog, {
    visible: display.value,
    "onUpdate:visible": _cache[14] || (_cache[14] = ($event: any) => ((display).value = $event)),
    modal: true,
    class: "reg-dialog tech",
    baseZIndex: 104,
    closable: false
  }, {
    header: _withCtx(() => [
      _createVNode(Header)
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            (showSpinner.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                  _createVNode(_component_ProgressSpinner)
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_5, [
                  _createElementVNode("div", _hoisted_6, [
                    _createVNode(_unref(PencilIcon), {
                      style: {"width":"60px"},
                      class: "mobile-hide"
                    }),
                    (!isDirectSignUp.value)
                      ? (_openBlock(), _createElementBlock("h1", _hoisted_7, _toDisplayString(_unref(t)("registration.popup.headline1")), 1))
                      : (_openBlock(), _createElementBlock("h1", _hoisted_8, _toDisplayString(_unref(t)("registration.tech.headline2")), 1)),
                    _createVNode(Timeline, { step: step.value }, null, 8, ["step"]),
                    (!isDirectSignUp.value)
                      ? (_openBlock(), _createElementBlock("p", _hoisted_9, _toDisplayString(_unref(t)("registration.headline4")), 1))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("div", _hoisted_10, [
                    _createElementVNode("div", _hoisted_11, [
                      _createElementVNode("div", null, [
                        _createElementVNode("span", _hoisted_12, [
                          _createVNode(_component_Dropdown, {
                            id: "salutation",
                            "data-cy": "wizard-salutation",
                            modelValue: _unref(v$).salutation.$model,
                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(v$).salutation.$model) = $event)),
                            options: salutations.value,
                            class: _normalizeClass({'p-invalid':_unref(v$).salutation.$error && submit.value})
                          }, null, 8, ["modelValue", "options", "class"]),
                          _createElementVNode("label", _hoisted_13, _toDisplayString(_unref(t)("salutation")) + " *", 1)
                        ]),
                        (submit.value)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(v$).salutation.$errors, (error, index) => {
                                return (_openBlock(), _createElementBlock("small", {
                                  class: "p-error",
                                  key: index
                                }, _toDisplayString(_unref(t)(error.$message)), 1))
                              }), 128))
                            ]))
                          : _createCommentVNode("", true)
                      ]),
                      _createElementVNode("div", null, [
                        _createElementVNode("span", _hoisted_15, [
                          _createVNode(_component_Dropdown, {
                            id: "title",
                            modelValue: _unref(v$).academicTitle.$model,
                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(v$).academicTitle.$model) = $event)),
                            options: titles.value,
                            class: _normalizeClass({'p-invalid':_unref(v$).academicTitle.$error && submit.value})
                          }, null, 8, ["modelValue", "options", "class"]),
                          _createElementVNode("label", _hoisted_16, _toDisplayString(_unref(t)("academic.title")), 1)
                        ]),
                        (submit.value)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(v$).academicTitle.$errors, (error, index) => {
                                return (_openBlock(), _createElementBlock("small", {
                                  class: "p-error",
                                  key: index
                                }, _toDisplayString(_unref(t)(error.$message)), 1))
                              }), 128))
                            ]))
                          : _createCommentVNode("", true)
                      ]),
                      _createElementVNode("div", null, [
                        _createElementVNode("span", _hoisted_18, [
                          _createVNode(_component_InputText, {
                            id: "firstName",
                            "data-cy": "wizard-firstName",
                            modelValue: user.value.firstName,
                            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((user.value.firstName) = $event)),
                            type: "text",
                            class: _normalizeClass({'p-invalid':_unref(v$).firstName.$error && submit.value})
                          }, null, 8, ["modelValue", "class"]),
                          _createElementVNode("label", _hoisted_19, _toDisplayString(_unref(t)("profile.form.firstname")) + " *", 1)
                        ]),
                        (submit.value)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(v$).firstName.$errors, (error, index) => {
                                return (_openBlock(), _createElementBlock("small", {
                                  class: "p-error",
                                  key: index
                                }, _toDisplayString(_unref(t)(error.$message)), 1))
                              }), 128))
                            ]))
                          : _createCommentVNode("", true)
                      ]),
                      _createElementVNode("div", null, [
                        _createElementVNode("span", _hoisted_21, [
                          _createVNode(_component_InputText, {
                            id: "lastName",
                            "data-cy": "wizard-lastName",
                            modelValue: _unref(v$).lastName.$model,
                            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_unref(v$).lastName.$model) = $event)),
                            type: "text",
                            class: _normalizeClass({'p-invalid':_unref(v$).lastName.$error && submit.value})
                          }, null, 8, ["modelValue", "class"]),
                          _createElementVNode("label", _hoisted_22, _toDisplayString(_unref(t)("profile.form.lastname")) + " *", 1)
                        ]),
                        (submit.value)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(v$).lastName.$errors, (error, index) => {
                                return (_openBlock(), _createElementBlock("small", {
                                  class: "p-error",
                                  key: index
                                }, _toDisplayString(_unref(t)(error.$message)), 1))
                              }), 128))
                            ]))
                          : _createCommentVNode("", true)
                      ]),
                      _createElementVNode("div", _hoisted_24, [
                        _createElementVNode("span", _hoisted_25, [
                          _createVNode(_component_InputText, {
                            type: "tel",
                            modelValue: _unref(v$).phoneNumber.$model,
                            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_unref(v$).phoneNumber.$model) = $event)),
                            class: _normalizeClass({ 'p-invalid': _unref(v$).phoneNumber.$error && submit.value }),
                            "data-cy": "wizard-phoneNumber"
                          }, null, 8, ["modelValue", "class"]),
                          _hoisted_26,
                          _createElementVNode("label", null, _toDisplayString(_unref(t)("phone") + (isDirectSignUp.value ? "" : " *")), 1)
                        ]),
                        (submit.value)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(v$).phoneNumber.$errors, (error, index) => {
                                return (_openBlock(), _createElementBlock("small", {
                                  class: "p-error",
                                  key: index
                                }, _toDisplayString(_unref(t)(error.$message)), 1))
                              }), 128))
                            ]))
                          : _createCommentVNode("", true)
                      ]),
                      _createElementVNode("div", _hoisted_28, [
                        _createElementVNode("span", _hoisted_29, [
                          _createVNode(_component_AutoComplete, {
                            forceSelection: "",
                            autoHighlight: true,
                            class: _normalizeClass({ 'p-invalid': _unref(v$).zipCode.$error && submit.value }),
                            modelValue: readableLocation.value,
                            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((readableLocation).value = $event)),
                            onComplete: _cache[6] || (_cache[6] = ($event: any) => (loadLocations($event))),
                            suggestions: locations.value,
                            onClear: _cache[7] || (_cache[7] = ($event: any) => (user.value.zipCode='')),
                            onItemSelect: _cache[8] || (_cache[8] = ($event: any) => (locationItemSelected($event))),
                            "data-cy": "wizard-zipCode"
                          }, null, 8, ["class", "modelValue", "suggestions"]),
                          _createElementVNode("label", null, _toDisplayString(_unref(t)("place.of.residence.postcode") + (isDirectSignUp.value ? "" : " *")), 1)
                        ]),
                        (submit.value)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(v$).zipCode.$errors, (error, index) => {
                                return (_openBlock(), _createElementBlock("small", {
                                  class: "p-error",
                                  key: index
                                }, _toDisplayString(_unref(t)(error.$message)), 1))
                              }), 128))
                            ]))
                          : _createCommentVNode("", true)
                      ]),
                      (!isDirectSignUp.value)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
                            _createElementVNode("span", _hoisted_32, [
                              _createVNode(_component_InputText, {
                                id: "emailAddress",
                                type: "username",
                                modelValue: _unref(v$).emailAddress.$model,
                                "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_unref(v$).emailAddress.$model) = $event)),
                                "data-cy": "reg-usermail",
                                onkeypress: checkMail(),
                                class: _normalizeClass({'p-invalid':_unref(v$).emailAddress.$error && submit.value || showLoginInsteadOfContinue.value})
                              }, null, 8, ["modelValue", "onkeypress", "class"]),
                              _createElementVNode("label", _hoisted_33, _toDisplayString(_unref(t)("registration.label1")) + " *", 1)
                            ]),
                            (submit.value)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(v$).emailAddress.$errors, (error, index) => {
                                    return (_openBlock(), _createElementBlock("small", {
                                      id: "no-email",
                                      class: "p-error",
                                      key: index
                                    }, _toDisplayString(_unref(t)(error.$message)), 1))
                                  }), 128))
                                ]))
                              : _createCommentVNode("", true),
                            _createElementVNode("div", null, [
                              (showLoginInsteadOfContinue.value)
                                ? (_openBlock(), _createElementBlock("small", _hoisted_35, _toDisplayString(_unref(t)("registration.error3")), 1))
                                : _createCommentVNode("", true)
                            ])
                          ]))
                        : _createCommentVNode("", true),
                      _createElementVNode("div", _hoisted_36, [
                        _createElementVNode("span", _hoisted_37, [
                          _createVNode(_component_Password, {
                            id: "password",
                            modelValue: _unref(v$).password.$model,
                            "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_unref(v$).password.$model) = $event)),
                            autocomplete: "one-time-code",
                            feedback: false,
                            toggleMask: "",
                            "data-cy": "reg-password",
                            class: _normalizeClass({'p-invalid':_unref(v$).password.$error && submit.value})
                          }, {
                            header: _withCtx(() => [
                              _createElementVNode("h3", null, _toDisplayString(_unref(t)("registration.password.choose")), 1),
                              _createElementVNode("h6", null, _toDisplayString(_unref(t)("registration.password.strength")), 1)
                            ]),
                            footer: _withCtx((sp) => [
                              _createTextVNode(_toDisplayString(sp.level) + " ", 1),
                              _createVNode(_component_Divider),
                              _createElementVNode("h6", null, _toDisplayString(_unref(t)("registration.password.hint")), 1),
                              _createElementVNode("ul", _hoisted_38, [
                                _createElementVNode("li", null, _toDisplayString(_unref(t)("registration.password.hint.signs")), 1)
                              ])
                            ]),
                            _: 1
                          }, 8, ["modelValue", "class"]),
                          _createElementVNode("label", _hoisted_39, _toDisplayString(_unref(t)("password")) + " *", 1)
                        ]),
                        _createElementVNode("div", null, [
                          (_unref(v$).password.$model && _unref(v$).password.$model.length < 8)
                            ? (_openBlock(), _createElementBlock("small", _hoisted_40, [
                                _createTextVNode(_toDisplayString(_unref(t)("registration.password.safety")) + " ", 1),
                                _createElementVNode("span", null, _toDisplayString((8 - _unref(v$).password.$model.length)) + " " + _toDisplayString(_unref(t)('registration.password.charleft')), 1)
                              ]))
                            : _createCommentVNode("", true)
                        ]),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(v$).password.$errors, (error, index) => {
                          return (_openBlock(), _createElementBlock("small", {
                            class: "p-error",
                            key: index
                          }, _toDisplayString(_unref(t)(error.$message)), 1))
                        }), 128))
                      ]),
                      _createElementVNode("div", _hoisted_41, [
                        _createElementVNode("span", _hoisted_42, [
                          _createVNode(_component_Password, {
                            id: "password2",
                            modelValue: _unref(v$).password2.$model,
                            "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_unref(v$).password2.$model) = $event)),
                            feedback: false,
                            toggleMask: "",
                            autocomplete: "one-time-code",
                            "data-cy": "reg-password-repeat",
                            class: _normalizeClass({'p-invalid':_unref(v$).password2.$error && submit.value || _unref(v$).password.$model && _unref(v$).password2.$model && _unref(v$).password.$model != _unref(v$).password2.$model})
                          }, null, 8, ["modelValue", "class"]),
                          _createElementVNode("label", _hoisted_43, _toDisplayString(_unref(t)("registration.password.repeat")) + " *", 1)
                        ]),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(v$).password2.$errors, (error, index) => {
                          return (_openBlock(), _createElementBlock("small", {
                            class: "p-error",
                            key: index
                          }, _toDisplayString(_unref(t)(error.$message)), 1))
                        }), 128)),
                        (submit.value && _unref(v$).password.$model && _unref(v$).password2.$model && _unref(v$).password.$model != _unref(v$).password2.$model)
                          ? (_openBlock(), _createElementBlock("small", _hoisted_44, _toDisplayString(_unref(t)('validate.password.sameas.error')), 1))
                          : _createCommentVNode("", true)
                      ])
                    ]),
                    (!isDirectSignUp.value)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_45, [
                          _createElementVNode("span", _hoisted_46, [
                            _createVNode(_component_Checkbox, {
                              id: "acceptTermsAndConditions",
                              "data-cy": "termsAndConditionsCheckbox",
                              modelValue: _unref(v$).acceptTermsAndConditions.$model,
                              "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_unref(v$).acceptTermsAndConditions.$model) = $event)),
                              binary: true,
                              class: _normalizeClass({'p-invalid':_unref(v$).acceptTermsAndConditions.$error && submit.value})
                            }, null, 8, ["modelValue", "class"]),
                            _createElementVNode("label", _hoisted_47, [
                              _createTextVNode(_toDisplayString(_unref(t)("registration.data.policy.label1")) + " ", 1),
                              _createElementVNode("a", _hoisted_48, _toDisplayString(_unref(t)("privacy.policy")), 1),
                              _createTextVNode(_toDisplayString(_unref(t)("registration.data.policy.label2")) + " * ", 1)
                            ])
                          ]),
                          (submit.value)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_49, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(v$).acceptTermsAndConditions.$errors, (error, index) => {
                                  return (_openBlock(), _createElementBlock("small", {
                                    class: "p-error",
                                    key: index
                                  }, _toDisplayString(_unref(t)(error.$message)), 1))
                                }), 128))
                              ]))
                            : _createCommentVNode("", true)
                        ]))
                      : _createCommentVNode("", true),
                    (error.value)
                      ? (_openBlock(), _createElementBlock("b", _hoisted_50, _toDisplayString(error.value), 1))
                      : _createCommentVNode("", true),
                    _createElementVNode("div", _hoisted_51, [
                      (isDirectSignUp.value)
                        ? (_openBlock(), _createBlock(_component_Button, {
                            key: 0,
                            "data-cy": "button-profile-prev",
                            class: "button-secondary button-back p-pl-3",
                            onClick: _cache[13] || (_cache[13] = ($event: any) => (prev()))
                          }, {
                            default: _withCtx(() => [
                              _hoisted_52,
                              _createTextVNode(_toDisplayString(_unref(t)("back")), 1)
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true),
                      (!showLoginInsteadOfContinue.value)
                        ? (_openBlock(), _createBlock(_component_Button, {
                            key: 1,
                            onClick: signup,
                            "data-cy": "button-profile-next",
                            class: "button-primary button-next p-pr-3"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(isDirectSignUp.value ? _unref(t)('submit') : _unref(t)('continue')) + " ", 1),
                              _hoisted_53
                            ]),
                            _: 1
                          }))
                        : (_openBlock(), _createBlock(_component_Button, {
                            key: 2,
                            onClick: login,
                            "data-cy": "button-profile-next",
                            class: "button-primary stretch button-next p-pr-3"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_unref(t)('registration.button.continue.login')) + " ", 1),
                              _hoisted_54
                            ]),
                            _: 1
                          }))
                    ])
                  ])
                ]))
          ]),
          _createElementVNode("div", _hoisted_55, [
            _createElementVNode("div", _hoisted_56, [
              _hoisted_57,
              _createElementVNode("div", _hoisted_58, _toDisplayString(_unref(t)("registration.tech.headline1")), 1)
            ])
          ])
        ])
      ])
    ]),
    _: 1
  }, 8, ["visible"]))
}
}

})